import React, { FC, HTMLAttributes } from 'react'
import { Box } from '@chakra-ui/core'

interface IProps extends HTMLAttributes<HTMLDivElement> {
    price: number | null
    currency: string
    discountPrice?: number
    fontSize?: string
}

export const Price: FC<IProps> = ({ price = 0, currency, discountPrice, fontSize="md" }: IProps) => {
    return (
        <Box fontFamily="body" fontSize={fontSize} color="primary.500" d="flex" alignItems="baseline" marginBottom="4px">
            {`${currency} ${discountPrice || price}`}
            {discountPrice && (
                <Box fontSize="xs" color="white" textDecoration="line-through" marginLeft="4px">
                    {`${currency} ${price?.toFixed(2)}`}
                </Box>
            )}
        </Box>
    )
}
